import React, { useEffect, useState } from 'react';
import CustomFormCreate from './CustomFormCreate';
import CustomFormEditor from './CustomFormEditor';
import Header from '../../../common/Header/Header';
import { getQueryData } from '../../../../utils';

function CustomForm() {
    const [formId, setFormId] = useState(null);
    const [isFormCreationRequested, setIsFormCreationRequested] = useState(false);
    const [submittedForms, setSubmittedForms] = useState([]);
    const [formDataToEdit, setFormDataToEdit] = useState(null);
    const [fileForm, setFileForm] = useState();

    useEffect(()=>{
        const query = `
        query MyQuery {
            allForms {
              id
              title
              questionSet {
                id
                required
                title
                questionType {
                  name
                }
                optionSet {
                  text
                }
              }
            }
          }`;

        getQueryData(query, "newcustomforms")
        .then((data)=>{
            setSubmittedForms(data.data.allForms);
        })
        .catch((error)=>{
            console.log(error);
        })
    },[])

    useEffect(()=>{
        console.log(submittedForms);
    },[submittedForms])


    // File Upload Checking
    // useEffect(() => {
    //     const queryfile = `
    //         query ThisQuery {
    //             form(id: $id) {
    //                 questionSet {
    //                   title
    //                   type {
    //                     name
    //                   }
    //                 }
    //             }
    //         }
    //     `;

    //     getQueryData(queryfile, "newcustomforms")
    //     .then((data)=>{
    //         const responseFileQueryData = data.data.form.questionSet[0].type.name;
    //         setFileForm(responseFileQueryData);
    //         console.log("wesrdtfygh",fileForm);
    //     }).catch((error)=>{
    //         console.log(error);
    //     })
    // })

    // const sendFormData = (e) => {
    //     e.preventDefault();
      
    //     const fileInput = document.getElementById("file");
    //     const file = fileInput.files[0];
      
    //     if (!file) {
    //       console.log("No file selected.");
    //       return;
    //     }
      
    //     const reader = new FileReader();
      
    //     reader.onload = () => {
    //       const base64Data = reader.result 
    //       const file_name  = file.name;
    //       console.log(base64Data);
    //       const UploadQuery = `
    //         mutation {
    //           createUserSubmission(files: "${file_name}_${base64Data}", formId: 156, userEmail: "sonali@gmail.com", response: "[]") {
    //             userSubmission {
    //               userEmail
    //               response
    //             }
    //           }
    //         }
    //       `;
      
    //       getQueryData(UploadQuery, "newcustomforms")
    //         .then((data) => {
    //           console.log("File Uploaded successfully", data);
    //         })
    //         .catch((error) => {
    //           console.log("Error uploading file", error);
    //         });
    //     };
    //     reader.readAsDataURL(file);
    // };
      



    const handleFormCreate = (formId) => {
        setFormId(formId);
        setIsFormCreationRequested(true);
        setFormDataToEdit(null);
    };

    const handleFormSubmit = (formData) => {
        const existingFormIndex = submittedForms.findIndex((form) => form.id === formData.id);

        if (existingFormIndex !== -1) {
            const updatedForms = [...submittedForms];
            updatedForms[existingFormIndex] = formData;
            setSubmittedForms(updatedForms);
        } else {
            setSubmittedForms([...submittedForms, formData]);
        }

        setIsFormCreationRequested(false);
    };

    const handleFormEdit = (id,formData) => {
        setFormId(id);
        setFormDataToEdit(formData);
        setIsFormCreationRequested(true);
    };

    return (
        <>
            <Header />
            <section className='background-dark-primary common-style'>
                <div>
                    {isFormCreationRequested ? (
                        <CustomFormEditor
                            formId={formId}
                            formDataToEdit={formDataToEdit}
                            onSubmit={handleFormSubmit}
                        />
                    ) : (
                        <CustomFormCreate onFormCreate={handleFormCreate} />
                    )}
                </div>
            </section>

            <section className='background-dark-primary py-5'>
                <div className='container'>
                    <div className='text-center'>
                        <h3 className='mb-5 text-white text-uppercase'>Submitted Forms</h3>
                    </div>

                    <div>
                        <table class="table table-striped text-center table-dark">
                            <thead>
                                <tr>
                                    <th>Form Id</th>
                                    <th>Form Title</th>
                                    <th>Edit</th>
                                    <th>Preview</th>
                                </tr>
                            </thead>
                            <tbody>
                            {submittedForms.map((formData, index) => (
                                <tr key={index}>
                                    <td>{formData.id}</td>
                                    <td>{formData.title}</td>
                                    <td>                                
                                        <button onClick={() => handleFormEdit(formData.id, formData)} className="btn btn-dark btn-dark-primary btn-sm d-flex align-items-center mx-auto">
                                            <svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                <path d="M4.18404 2.43597L4.72883 3.50518L4.72883 3.50518L4.18404 2.43597ZM2.43597 4.18404L1.36677 3.63925L1.36677 3.63925L2.43597 4.18404ZM17.816 19.564L18.3608 20.6332L17.816 19.564ZM19.564 17.816L18.4948 17.2712V17.2712L19.564 17.816ZM4.18404 19.564L4.72883 18.4948H4.72883L4.18404 19.564ZM2.43597 17.816L3.50518 17.2712L2.43597 17.816ZM21.2 11C21.2 10.3373 20.6627 9.8 20 9.8C19.3373 9.8 18.8 10.3373 18.8 11H21.2ZM11 3.2C11.6627 3.2 12.2 2.66274 12.2 2C12.2 1.33726 11.6627 0.8 11 0.8V3.2ZM11.2532 9.49659L12.3916 9.87606V9.87606L11.2532 9.49659ZM11.716 8.10821L10.5776 7.72873L10.5776 7.72874L11.716 8.10821ZM12.1935 7.33555L13.0421 8.18408L13.0421 8.18408L12.1935 7.33555ZM16.8054 2.72371L15.9569 1.87518L15.9569 1.87518L16.8054 2.72371ZM19.2763 5.19461L20.1248 6.04314V6.04314L19.2763 5.19461ZM14.6644 9.80645L13.8159 8.95793L13.8159 8.95793L14.6644 9.80645ZM13.8918 10.284L14.2713 11.4224L14.2713 11.4224L13.8918 10.284ZM12.5034 10.7468L12.8829 11.8852L12.8829 11.8852L12.5034 10.7468ZM14.4112 10.0429L15.1338 11.0009L15.1338 11.0009L14.4112 10.0429ZM14.2165 10.1632L13.6829 9.08835L13.6829 9.08835L14.2165 10.1632ZM19.2763 2.72371L18.4278 3.57224V3.57224L19.2763 2.72371ZM19.8715 3.4106L20.9468 2.87778V2.87778L19.8715 3.4106ZM19.8715 4.50772L20.9468 5.04054V5.04054L19.8715 4.50772ZM17.4923 2.12846L18.0251 3.20369V3.20369L17.4923 2.12846ZM18.5894 2.12846L18.0566 3.20369L18.0566 3.20369L18.5894 2.12846ZM11.8368 7.78347L12.9117 8.31712V8.31712L11.8368 7.78347ZM11.9571 7.58885L10.9991 6.86616L10.9991 6.86616L11.9571 7.58885ZM11.023 10.6026L12.1533 10.1996L11.023 10.6026ZM11.3974 10.977L10.9943 12.1073L11.3974 10.977ZM8.4 21.2H13.6V18.8H8.4V21.2ZM0.8 8.4V13.6H3.2V8.4H0.8ZM8.4 0.8C7.2997 0.8 6.4023 0.799067 5.67509 0.858482C4.93387 0.919042 4.26443 1.04822 3.63925 1.36677L4.72883 3.50518C4.95929 3.38776 5.27773 3.29895 5.87053 3.25051C6.47733 3.20093 7.26009 3.2 8.4 3.2V0.8ZM3.2 8.4C3.2 7.26009 3.20093 6.47733 3.25051 5.87053C3.29895 5.27773 3.38776 4.95929 3.50518 4.72883L1.36677 3.63925C1.04822 4.26443 0.919042 4.93387 0.858482 5.67509C0.799067 6.4023 0.8 7.2997 0.8 8.4H3.2ZM3.63925 1.36677C2.66081 1.86531 1.86531 2.66081 1.36677 3.63925L3.50518 4.72883C3.77363 4.20197 4.20197 3.77363 4.72883 3.50518L3.63925 1.36677ZM13.6 21.2C14.7003 21.2 15.5977 21.2009 16.3249 21.1415C17.0661 21.081 17.7356 20.9518 18.3608 20.6332L17.2712 18.4948C17.0407 18.6122 16.7223 18.7011 16.1295 18.7495C15.5227 18.7991 14.7399 18.8 13.6 18.8V21.2ZM18.8 13.6C18.8 14.7399 18.7991 15.5227 18.7495 16.1295C18.7011 16.7223 18.6122 17.0407 18.4948 17.2712L20.6332 18.3608C20.9518 17.7356 21.081 17.0661 21.1415 16.3249C21.2009 15.5977 21.2 14.7003 21.2 13.6H18.8ZM18.3608 20.6332C19.3392 20.1347 20.1347 19.3392 20.6332 18.3608L18.4948 17.2712C18.2264 17.798 17.798 18.2264 17.2712 18.4948L18.3608 20.6332ZM8.4 18.8C7.26009 18.8 6.47733 18.7991 5.87053 18.7495C5.27773 18.7011 4.95929 18.6122 4.72883 18.4948L3.63925 20.6332C4.26443 20.9518 4.93387 21.081 5.67509 21.1415C6.4023 21.2009 7.2997 21.2 8.4 21.2V18.8ZM0.8 13.6C0.8 14.7003 0.799067 15.5977 0.858482 16.3249C0.919042 17.0661 1.04822 17.7356 1.36677 18.3608L3.50518 17.2712C3.38776 17.0407 3.29895 16.7223 3.25051 16.1295C3.20093 15.5227 3.2 14.7399 3.2 13.6H0.8ZM4.72883 18.4948C4.20197 18.2264 3.77363 17.798 3.50518 17.2712L1.36677 18.3608C1.86531 19.3392 2.66081 20.1347 3.63925 20.6332L4.72883 18.4948ZM21.2 13.6V11H18.8V13.6H21.2ZM8.4 3.2H11V0.8H8.4V3.2ZM12.3916 9.87606L12.8544 8.48768L10.5776 7.72874L10.1148 9.11711L12.3916 9.87606ZM13.0421 8.18408L17.6539 3.57224L15.9569 1.87518L11.345 6.48702L13.0421 8.18408ZM18.4278 4.34609L13.8159 8.95793L15.513 10.655L20.1248 6.04314L18.4278 4.34609ZM13.5123 9.14556L12.1239 9.60836L12.8829 11.8852L14.2713 11.4224L13.5123 9.14556ZM13.8159 8.95793C13.75 9.02385 13.7172 9.0565 13.6926 9.07981C13.6729 9.09844 13.6755 9.09469 13.6885 9.0849L15.1338 11.0009C15.2845 10.8872 15.4126 10.7554 15.513 10.655L13.8159 8.95793ZM14.2713 11.4224C14.406 11.3775 14.5811 11.3219 14.7502 11.238L13.6829 9.08835C13.6974 9.08112 13.702 9.08047 13.6765 9.08974C13.6446 9.10135 13.6008 9.11608 13.5123 9.14556L14.2713 11.4224ZM13.6885 9.0849C13.6867 9.08621 13.6848 9.08737 13.6829 9.08835L14.7502 11.238C14.8851 11.171 15.0136 11.0916 15.1338 11.0009L13.6885 9.0849ZM18.4278 3.57224C18.6058 3.75023 18.7037 3.84885 18.7713 3.92455C18.8333 3.99397 18.8192 3.98967 18.7963 3.94342L20.9468 2.87778C20.7473 2.47518 20.3931 2.14349 20.1248 1.87518L18.4278 3.57224ZM20.1248 6.04314C20.3931 5.77484 20.7473 5.44315 20.9468 5.04054L18.7963 3.9749C18.8192 3.92866 18.8333 3.92436 18.7713 3.99377C18.7037 4.06947 18.6058 4.1681 18.4278 4.34609L20.1248 6.04314ZM18.7963 3.94342C18.8012 3.95334 18.8012 3.96498 18.7963 3.9749L20.9468 5.04054C21.2844 4.35916 21.2844 3.55917 20.9468 2.87778L18.7963 3.94342ZM17.6539 3.57224C17.8319 3.39425 17.9305 3.29626 18.0062 3.22867C18.0756 3.16669 18.0713 3.18077 18.0251 3.20369L16.9595 1.05324C16.5569 1.25275 16.2252 1.60688 15.9569 1.87518L17.6539 3.57224ZM20.1248 1.87518C19.8565 1.60688 19.5248 1.25275 19.1222 1.05324L18.0566 3.20369C18.0103 3.18077 18.006 3.16669 18.0754 3.22867C18.1511 3.29626 18.2498 3.39425 18.4278 3.57224L20.1248 1.87518ZM18.0251 3.20369C18.035 3.19877 18.0467 3.19877 18.0566 3.20369L19.1222 1.05324C18.4408 0.715586 17.6408 0.715586 16.9595 1.05324L18.0251 3.20369ZM12.8544 8.48769C12.8839 8.39925 12.8986 8.35537 12.9103 8.3235C12.9195 8.29803 12.9189 8.30255 12.9117 8.31712L10.762 7.24983C10.6781 7.4189 10.6225 7.59403 10.5776 7.72873L12.8544 8.48769ZM11.345 6.48702C11.2446 6.58743 11.1128 6.71546 10.9991 6.86616L12.9151 8.31153C12.9053 8.32452 12.9016 8.32712 12.9202 8.30743C12.9435 8.2828 12.9762 8.25 13.0421 8.18408L11.345 6.48702ZM12.9117 8.31712C12.9126 8.31515 12.9138 8.31329 12.9151 8.31153L10.9991 6.86616C10.9084 6.98644 10.829 7.11488 10.762 7.24983L12.9117 8.31712ZM10.1148 9.11711C10.0218 9.39621 9.92451 9.68419 9.86765 9.92619C9.81496 10.1504 9.7352 10.564 9.89271 11.0057L12.1533 10.1996C12.1988 10.3272 12.2014 10.4298 12.1996 10.4757C12.1981 10.5159 12.1928 10.5229 12.204 10.4752C12.2147 10.4296 12.2338 10.3616 12.267 10.2561C12.2999 10.1514 12.3404 10.0298 12.3916 9.87606L10.1148 9.11711ZM12.1239 9.60836C11.9702 9.6596 11.8486 9.7001 11.7439 9.73304C11.6384 9.76624 11.5704 9.78528 11.5248 9.79599C11.477 9.80721 11.4841 9.80191 11.5243 9.80038C11.5702 9.79863 11.6728 9.80121 11.8004 9.84671L10.9943 12.1073C11.436 12.2648 11.8496 12.185 12.0738 12.1324C12.3158 12.0755 12.6038 11.9782 12.8829 11.8852L12.1239 9.60836ZM9.89271 11.0057C10.076 11.5196 10.4804 11.924 10.9943 12.1073L11.8004 9.84671C11.965 9.90542 12.0946 10.035 12.1533 10.1996L9.89271 11.0057Z" fill="white"/>
                                            </svg>
                                            Edit
                                        </button>
                                    </td>
                                    <td>
                                        <button className='btn btn-dark btn-dark-primary btn-sm d-flex align-items-center mx-auto'>
                                            <svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M2.9095 13.1718C2.56793 12.4286 2.56793 11.5714 2.9095 10.8282C4.4906 7.38843 7.96659 5 12.0004 5C16.0343 5 19.5102 7.38843 21.0913 10.8282C21.4329 11.5714 21.4329 12.4286 21.0913 13.1718C19.5102 16.6116 16.0343 19 12.0004 19C7.96659 19 4.4906 16.6116 2.9095 13.1718Z" stroke="white" stroke-width="2"/>
                                                <path d="M15.0004 12C15.0004 13.6569 13.6573 15 12.0004 15C10.3436 15 9.00042 13.6569 9.00042 12C9.00042 10.3431 10.3436 9 12.0004 9C13.6573 9 15.0004 10.3431 15.0004 12Z" stroke="white" stroke-width="2"/>
                                            </svg>
                                            Preview
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {/* <div>
            {fileForm === 'file' ? (
                <section className='py-5'>
                    <div className="container mt-5">
                        <h2>File Upload Form</h2>
                        <form enctype="multipart/form-data">
                        <div className="form-group">
                            <label htmlFor="file">Choose a file:</label>
                            <input type="file" className="form-control-file" id="file" name="file" />
                        </div>
                        <button type="submit" className="btn btn-primary" onClick={sendFormData}>Upload</button>
                        </form>
                    </div>
                </section>
            ) : null}
            </div> */}
        </>
    );
}

export default CustomForm;
